import React from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import { Scrollbars } from "react-custom-scrollbars"
import ResponsiveTable from "../../themed-html-components/ResponsiveTable"
import { formatDateTimeForDisplay } from "../../../utils/formatting-utils"
import CustomReportSubmitSpinner from "../Modals/CustomReportSubmitSpinner"
import ReportDownloadButton from "./ReportDownloadButton"
import { RequestedReportShape } from "../../../state/shapes/CustomReportShapes"

const ReportRequestTable = ({
  t,
  reports,
  reportLoadingInProgress, // eslint-disable-line react/prop-types
  autoRefreshing, // eslint-disable-line react/prop-types
}) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12">
          {reportLoadingInProgress && !autoRefreshing ? (
            <CustomReportSubmitSpinner />
          ) : (
            <Scrollbars autoHeight autoHeightMin={300} autoHeightMax={500}>
              <ResponsiveTable>
                <thead>
                  <tr>
                    <th>{t("CustomReport.RequestedReport.ReportType")}</th>
                    <th>{t("CustomReport.RequestedReport.RequestDate")}</th>
                    <th>{t("CustomReport.RequestedReport.Status")}</th>
                    <th>{t("CustomReport.RequestedReport.ReviewName")}</th>
                    <th>{t("CustomReport.RequestedReport.Download")}</th>
                  </tr>
                </thead>

                <tbody>
                  {reports && reports.length > 0 ? (
                    reports.map((report) => {
                      return (
                        <tr key={report.reportId}>
                          <td>{t(report.reportType)}</td>
                          <td>{formatDateTimeForDisplay(report.requestedDate)}</td>
                          <td>{t(report.requestStatus)}</td>
                          <td>
                            {report.reviewName === "Reviews.Review-1" ? "" : t(report.reviewName)}
                          </td>
                          <td>
                            {report.downloadLink ? (
                              <ReportDownloadButton
                                reportId={report.reportId}
                                label="CustomReport.RequestedReport.Download"
                              />
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td>{t("CustomReport.RequestedReport.NoReportsRequested")}</td>
                    </tr>
                  )}
                </tbody>
              </ResponsiveTable>
            </Scrollbars>
          )}
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    reports: state.customReport.requestedReports,
    reportLoadingInProgress: state.customReport.reportLoadingInProgress,
    autoRefreshing: state.customReport.autoRefreshing,
  }
}

ReportRequestTable.propTypes = {
  t: PropTypes.func.isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape(RequestedReportShape)).isRequired,
}

export default compose(translate(), connect(mapStateToProps))(ReportRequestTable)



// WEBPACK FOOTER //
// ./src/components/custom-report/ReportRequestsTab/ReportRequestTable.jsx